<script>
  import { programSection } from './program.js';
</script>

<section id="program" class="program-section" aria-labelledby="program-title">
  <div class="program-inner">
    <div class="program-content">
      <div class="program-head">
        <div class="program-copy">
          <div class="title-group">
            <h2 id="program-title">{programSection.title}</h2>
            <div class="section-line" aria-hidden="true"></div>
          </div>

          <p>{programSection.description}</p>
        </div>

        <div class="program-spacer" aria-hidden="true"></div>
      </div>

      <div class="topics-grid" aria-label="Темы форума">
        {#each programSection.topics as topic}
          <a class="topic-card" href={topic.href}>
            <span>{topic.title}</span>
            <span class="topic-arrow" aria-hidden="true">›</span>
          </a>
        {/each}
      </div>
    </div>
  </div>
</section>

<style>
  .program-section {
    display: flex;
    justify-content: center;
    padding: 100px 0;
    background: #111111;
    color: #ffffff;
    font-family: Roboto, Arial, Helvetica, sans-serif;
    font-variation-settings: 'wdth' 100;
  }

  .program-inner {
    display: flex;
    width: min(100%, 1440px);
    align-items: center;
    justify-content: center;
    padding: 0 64px;
    box-sizing: border-box;
  }

  .program-content {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 48px;
    padding: 0 12px;
    box-sizing: border-box;
  }

  .program-head {
    display: flex;
    width: 100%;
    align-items: flex-start;
    gap: 32px;
  }

  .program-copy {
    display: flex;
    flex: 1 1 0;
    min-width: 0;
    flex-direction: column;
    gap: 24px;
  }

  .program-spacer {
    flex: 1 1 0;
    min-width: 0;
    height: 72px;
  }

  .title-group {
    display: flex;
    flex-direction: column;
    gap: 21px;
    align-items: flex-start;
  }

  h2,
  p {
    margin: 0;
  }

  h2 {
    color: #ffffff;
    font-size: 56px;
    font-weight: 700;
    line-height: 56px;
    text-transform: uppercase;
  }

  .section-line {
    width: 78px;
    height: 4px;
    background: #e7b962;
  }

  .program-copy p {
    color: rgba(255, 255, 255, 0.7);
    font-size: 30px;
    font-weight: 400;
    line-height: 36px;
  }

  .topics-grid {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;
  }

  .topic-card {
    display: flex;
    min-height: 90px;
    align-items: center;
    gap: 24px;
    padding: 12px 30px;
    border: 1px solid rgba(179, 140, 100, 0.15);
    border-radius: 12px;
    background: linear-gradient(128deg, rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.01) 100%);
    color: #e7b962;
    text-decoration: none;
    box-sizing: border-box;
    transition:
      border-color 200ms ease,
      background 200ms ease,
      transform 200ms ease,
      box-shadow 200ms ease;
  }

  .topic-card:hover,
  .topic-card:focus-visible {
    border-color: rgba(231, 185, 98, 0.55);
    background: linear-gradient(128deg, rgba(231, 185, 98, 0.10) 0%, rgba(255, 255, 255, 0.02) 100%);
    transform: translateX(6px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.35);
    text-decoration: none;
  }

  .topic-arrow {
    transition: transform 200ms ease;
  }

  .topic-card:hover .topic-arrow,
  .topic-card:focus-visible .topic-arrow {
    transform: translateX(4px);
  }

  @media (prefers-reduced-motion: reduce) {
    .topic-card,
    .topic-arrow { transition: none; }
    .topic-card:hover,
    .topic-card:focus-visible { transform: none; }
    .topic-card:hover .topic-arrow,
    .topic-card:focus-visible .topic-arrow { transform: none; }
  }

  .topic-card span:first-child {
    flex: 1 1 auto;
    min-width: 0;
    font-size: 22px;
    font-weight: 500;
    line-height: 24px;
  }

  .topic-arrow {
    flex: 0 0 auto;
    width: 24px;
    color: currentColor;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 20px;
    font-weight: 400;
    line-height: 1;
    text-align: center;
    opacity: 0.7;
  }

  @media (max-width: 1279px) {
    .program-inner {
      padding: 0 32px;
    }

    .program-content {
      padding: 0 12px;
    }

    .program-head {
      display: block;
    }

    .program-copy {
      width: 100%;
    }

    .program-spacer {
      display: none;
    }

    .topics-grid {
      grid-template-columns: 1fr;
    }

    h2 {
      font-size: 40px;
      line-height: 1.1;
    }
  }

  @media (max-width: 1599px) and (min-width: 1280px) {
    h2 {
      font-size: 48px;
      line-height: 1.1;
    }
  }

  @media (max-width: 767px) {
    .program-section {
      padding: 40px 0;
    }

    .program-inner {
      padding: 0 24px;
    }

    .program-content {
      padding: 0;
    }

    h2 {
      font-size: 32px;
      line-height: 56px;
    }

    .program-copy p {
      font-size: 24px;
      line-height: 24px;
    }

    .topic-card {
      min-height: 48px;
      gap: 24px;
      padding: 12px 12px 12px 24px;
    }

    .topic-card span:first-child {
      font-size: 16px;
      line-height: normal;
    }
  }
</style>
